<template>
  <li
    class="column is-one-quarter-desktop is-one-third-tablet is-half-mobile"
    @click="onClick(liveId, type)"
  >
    <div class="thumbnail">
      <b-image :src="imageSrc" ratio="400by255" />
    </div>
    <p class="nickname" v-if="nickname">{{ nickname }}</p>
    <p class="startAt">{{ startAt }}</p>
    <p class="title">{{ title }}</p>
  </li>
</template>

<script>
import * as DateTime from '@/utils/date';

export default {
  name: 'LiveListedTile',
  props: {
    tileData: {
      type: Object,
      default() {
        return {
          liveId: '',
          imageSrc: '',
          nickname: '',
          startAt: '',
          title: '',
          type: ''
        };
      }
    },
    onClick: null
  },
  computed: {
    liveId() {
      return this.tileData.liveId;
    },
    link() {
      return this.tileData.link;
    },
    imageSrc() {
      return this.tileData.imageSrc;
    },
    nickname() {
      return this.tileData.nickname;
    },
    startAt() {
      return this.startAtText + DateTime.formatJSDate('yyyy/MM/dd HH:mm', this.tileData.startAt);
    },
    startAtText() {
      return this.type == "recentLive" ? "ライブ配信開始：" : "配信開始：";
    },
    title() {
      return this.tileData.title;
    },
    type() {
      return this.tileData.type;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/home.scss';

li {
  cursor: pointer;
}
.is-size-7 {
  overflow: hidden;
}
.nickname {
  font-weight: 600;
  font-size: 16px;
  color: $white;
}
.startAt {
  font-weight: normal;
  font-size: 14px;
  color: $white;
}
.title {
  font-weight: normal;
  font-size: 14px;
  color: $white;
}
</style>
